module.exports = __webpack_public_path__ + "fonts/opensans-semibold-webfont.b86f018.woff2";